import React from 'react';

// Splits text and renders @usernames as clickable links. onMention(handle)
// receives the bare handle (no @). Also linkifies a leading display name if
// provided (bold, clickable) before the text.
const HANDLE = /(@[a-z0-9_]{3,20})/gi;

export const MentionText = ({ text, onMention, className = '' }) => {
  if (!text) return null;
  const parts = String(text).split(HANDLE);
  return (
    <span className={className}>
      {parts.map((part, i) => {
        if (/^@[a-z0-9_]{3,20}$/i.test(part)) {
          const handle = part.slice(1).toLowerCase();
          return (
            <button
              key={i}
              type="button"
              onClick={() => onMention?.(handle)}
              className="text-primary font-medium hover:underline"
              data-testid={`mention-${handle}`}
            >
              {part}
            </button>
          );
        }
        return <React.Fragment key={i}>{part}</React.Fragment>;
      })}
    </span>
  );
};

export default MentionText;
